let musicData = {
  alphaWave1: { name: "Alpha Waves", src: "/alpha-waves-11hz.mp3" },
  deltaWave1: { name: "Delta Waves", src: "/delta-waves1-4hz.mp3" },
  deltaWave2: { name: "Delta Waves 2", src: "/delta-waves2.mp3" },
  gammaWave: { name: "Gamma Waves", src: "/gamma-waves.mp3" },
};

export default musicData;
